import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=81a80cb6&scoped=true&"
import script from "./ExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=81a80cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a80cb6",
  null
  
)

export default component.exports